import { authHeader } from "../helpers/auth-header";
import axios from 'axios';

const getList = () => {
    return axios.get(`/api/devicetypes/`, {headers: authHeader()})
        .then(res => { return res.data; })
};

const getDropDownList = () => {
    return axios.get('/api/devicetypes/getdropdownlist', { headers: authHeader() })
        .then(res => { return res.data; })
};

const addDeviceType = (deviceTypeModel) => {
    return axios.post(`/api/deviceTypes`, deviceTypeModel, {headers: authHeader()})
        .then(res => {return res.data })
};

const editDeviceType = (deviceTypeModel) => {
    return axios.patch(`/api/deviceTypes/${deviceTypeModel.id}`, deviceTypeModel, {headers: authHeader()})
        .then(res => {return res.data})
};

const deleteDeviceType = (deviceTypeId) => {
    return axios.delete(`/api/deviceTypes/${deviceTypeId}`, {headers: authHeader()})
        .then(res => {return res.data})
};

export const deviceTypeService = {
    getList,
    getDropDownList,
    addDeviceType,
    editDeviceType,
    deleteDeviceType
};
